import { render, staticRenderFns } from "./CoachAppSvg.vue?vue&type=template&id=7fc0594c&"
import script from "./CoachAppSvg.vue?vue&type=script&lang=ts&"
export * from "./CoachAppSvg.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports